export default __webpack_public_path__ + "static/media/pic6-1.b490a15c.jpg";